export default __webpack_public_path__ + "static/media/empty-chart.3b5dbcbd.svg";